










import { Component, Prop } from 'vue-property-decorator'
import DialogBase from '@/classes/Dialog'
import { Actions } from '@/store/global/actions'

@Component
export default class AreYouSureDialog extends DialogBase {
  @Prop() meta: any
  loading: boolean = false

  async onYes(): Promise<void> {
    const { onYes } = this.meta
    this.loading = true
    try {
      if (onYes) {
        await onYes()
      }

      if (!this.meta.dontCloseOnYes) {
        this.closeDialog()
      }
      this.loading = false
    } catch (error) {
      this.loading = false

      if (error.response) {
        await this.$store.dispatch(Actions.showSnackbar, {
          type: 'error',
          message: error.response.data.message,
        })
      }
    }
  }

  onNo(): void {
    const { onNo } = this.meta
    this.closeDialog()
    onNo && onNo()
  }
}
